import {kebabCase} from 'lodash-es';

export function getCtaAriaLabel(buttonLabel: string, title: string): string | undefined {
	if (!buttonLabel) {
		return undefined;
	}

	// Feel free to add more cases here
	if (kebabCase(buttonLabel) === 'dozvedet-se-vice') {
		return `${buttonLabel} o ${title}`;
	}

	return `${buttonLabel} - ${title}`;
}
